export const UI_MODE_SET = 'UI_MODE_SET';
export const SCROLL_LOCK_SET = 'SCROLL_LOCK_SET';
export const COMPONENT_FOCUS_SET = 'COMPONENT_FOCUS_SET';

export const COLORS_REQUEST = 'COLORS_REQUEST';
export const COLORS_RECEIVE = 'COLORS_RECEIVE';

export const COLOR_PALETTE_RECEIVE = 'COLOR_PALETTE_RECEIVE';
export const COLOR_PALETTE_REQUEST = 'COLOR_PALETTE_REQUEST';

export const INFO_CONSOLE_TOGGLE = 'INFO_CONSOLE_TOGGLE';

export const DECK_RECEIVE = 'DECK_RECEIVE';
export const INVITE_RECEIVE = 'INVITE_RECEIVE';

export const MOBILE_WELCOME_ACKNOWLEDGE = 'MOBILE_WELCOME_ACKNOWLEDGE';

export const SET_SEARCH_PARAMS = 'SET_SEARCH_PARAMS';

export const SLIDE_ROTATION_PAUSE_TOGGLE = 'SLIDE_ROTATION_PAUSE_TOGGLE';

export const TEST_RESET = 'TEST_RESET';
